import { Container, Box, Typography, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyComponent = () => {
  const { t } = useTranslation();

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          {t('privacyPolicy')}
        </Typography>
        <Typography variant="p" sx={{ mt: 1 }}>
          {t('lastUpdated')}
        </Typography>
      </Box>

      <Typography variant="body1" paragraph>
        {t('privacyPolicyIntro')}
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
        {t('dataCollectionTitle')}
      </Typography>
      <List>
        <ListItem>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t('personalData')}
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t('therapyData')}
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {t('technicalData')}
          </Typography>
        </ListItem>
      </List>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 2 }}>
        {t('dataUsageTitle')}
      </Typography>
      <List>
        <ListItem>{t('dataUsage1')}</ListItem>
        <ListItem>{t('dataUsage2')}</ListItem>
        <ListItem>{t('dataUsage3')}</ListItem>
        <ListItem>{t('dataUsage4')}</ListItem>
      </List>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
        {t('dataStorageTitle')}
      </Typography>
      <Typography variant="body1" paragraph>
        {t('dataProtection')}
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
        {t('userRightsTitle')}
      </Typography>
      <List>
        <ListItem>{t('userRights1')}</ListItem>
        <ListItem>{t('userRights2')}</ListItem>
        <ListItem>{t('userRights3')}</ListItem>
        <ListItem>{t('userRights4')}</ListItem>
      </List>

      <Typography variant="body1" sx={{ mt: 1 }}>
        {t('contactRights')}
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
        {t('privacyPolicyAcceptanceTitle')}
      </Typography>
      <Typography variant="body1" paragraph>
        {t('privacyPolicyAcceptance')}
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: "bold", mt: 3 }}>
        {t('contactTitle')}
      </Typography>
      <Typography variant="body1" paragraph>
        {t('contactIntro')}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
        {t('companyName')}
      </Typography>
      <Typography variant="body1">{t('companyAddress')}</Typography>
      <Typography variant="body1">{t('companyEmail')}</Typography>
      <Typography variant="body1">{t('companyPhone')}</Typography>

      <Typography variant="body2" paragraph sx={{ mt: 3 }}>
        {t('policyUpdateNotice')}
      </Typography>
    </Container>
  );
};

export { PrivacyPolicyComponent };
